/*
  YUNA wipe-in observer — single IntersectionObserver targeting elements
  carrying any of the wipe utility classes. On viewport entry it adds
  .is-visible to the element (single-fire then unobserve) and the CSS
  transition completes the visual.

  Scope: only elements that opt in via the merchant-applied class (typed
  into a block's "Custom CSS class" Theme Editor field). Above-the-fold
  elements fire immediately at observer init; below-the-fold ones fire
  as scrolled into view.

  Pairs with: assets/yuna-custom.css "wipe-in animation utilities" block.
  The CSS .yuna-js gate ensures hidden initial state ONLY applies when
  JS is confirmed running — without JS, content renders normally so the
  page is never broken by a missing animation.

  No fallback timer needed: if IntersectionObserver is unavailable, we
  reveal everything at init so content is never left invisible.
*/
(function () {
  'use strict';

  var SELECTOR = '.yuna-wipe, .yuna-fade-up, .yuna-blur-in, .yuna-scale-soft, .yuna-slide-in';

  function reveal(el) {
    el.classList.add('is-visible');
  }

  function init() {
    var els = document.querySelectorAll(SELECTOR);
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
